import React from 'react';
import { connect } from 'react-redux';
import Activity from './activity/Activity';
import ClientsContainer from './client/ClientsContainer';
import ClientAdd from './client/ClientAdd';
import { getClients, addClient } from '../ducks/clientActions';
import { CLEAR_CLIENT_STATE } from '../ducks/types';
import './home.scss';

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.props.loadClients();
    this.state = {
      openModal: false
    };
  }

  toggle = () => {
    this.props.clearState();
    this.setState({ openModal: !this.state.openModal });
  };

  render() {
    return (
      <div className="homepage main-wrapper">
        <div className="container">
          <div className="homepage-content">
            <Activity />
            {this.props.clients && (
              <ClientsContainer
                toggle={this.toggle}
                clients={this.props.clients}
                loadingState={this.props.loadingState}
              />
            )}
          </div>
        </div>
        <ClientAdd
          toggle={this.toggle}
          openModal={
            !this.props.clientAdded &&
            (this.props.addClientError != null || this.state.openModal)
          }
          error={this.props.addClientError}
          addClient={this.props.addClient}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    clients: state.clientReducer.clients,
    addClientError: state.clientReducer.error,
    clientAdded: state.clientReducer.success,
    loadingState: state.clientReducer.loadingState
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadClients: () => dispatch(getClients()),
    addClient: values => dispatch(addClient(values)),
    clearState: () => dispatch({ type: CLEAR_CLIENT_STATE })
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);
